export const msDelayPromise = ms =>
  new Promise(resolve => {
    setTimeout(resolve, ms)
  })

export const buildMsDelayPromise = (startTime, desiredTotalElapse) =>
  new Promise(resolve => {
    const now = new Date()
    const alreadyPassed = now - startTime
    const timeNeeded = desiredTotalElapse - alreadyPassed
    msDelayPromise(timeNeeded).then(resolve)
  })
